import React, { Component } from 'react';
import EventBus from 'eventing-bus';
import { ACTION_TYPES } from 'src/constants';
import { withRouter } from 'react-router-dom';
import cx from 'classnames';
import queryString from 'query-string';
import { Convert } from 'src/helpers';
import { Screen, Loader } from 'src/components';
import MobileSipTransactions from './mobileSipTransactions';
import DesktopSipTransactions from './desktopSipTransactions';
import SipTransactionsSuccess from '../sipTransactionsSuccess';
import styles from './_sipTransactions.module.scss';

// const IS_PRODUCTION = process.env.REACT_APP_ENV === 'production';
// const API_ENDPOINT_URL = IS_PRODUCTION
//   ? 'https://api.savvyapp.in'
//   : 'https://surface.thesavvyapp.in';

class SipTransactions extends Component {
  state = {
    amount: '',
    minAmount: '',
    noOfInstallments: '',
    minNoOfInstallments: 1,
    isSipCalendar: false,
    sipDate: new Date().getDate(),
    tempSipDate: new Date().getDate(),
    isLoading: false,
  };

  componentDidMount() {
    this.requestPaymentSubscription = EventBus.on(
      ACTION_TYPES.REQUEST_GENERATE_CHECKOUT_PAYMENT_SIP,
      () => this.setState({ isLoading: true }),
    );
    this.paymentSubscriptionSuccess = EventBus.on(
      ACTION_TYPES.GENERATE_CHECKOUT_PAYMENT_SIP_SUCCESS,
      this.onPaymentGenerated,
    );
    this.paymentSubscriptionFailure = EventBus.on(
      ACTION_TYPES.GENERATE_CHECKOUT_PAYMENT_SIP_FAILED,
      () => this.setState({ isLoading: false }),
    );

    this.requestCheckoutDetail = EventBus.on(ACTION_TYPES.ONE_CLICK_CHECKOUT_DETAIL_REQUEST, () =>
      this.setState({ isLoading: true }),
    );
    this.checkoutDetailSuccess = EventBus.on(
      ACTION_TYPES.ONE_CLICK_CHECKOUT_DETAIL_SUCCESS,
      this.onCheckoutDetailFetched,
    );
    this.checkoutDetailFailure = EventBus.on(ACTION_TYPES.ONE_CLICK_CHECKOUT_DETAIL_FAILED, () =>
      this.setState({ isLoading: false }),
    );

    // this.props.requestCheckoutDetail('f44b114e-7da8-42b7-b6c2-a58039d4b197');
    let { uuid, partnerAccessKey } = queryString.parse(this.props.location.search);

    if (uuid && partnerAccessKey) {
      this.props.requestCheckoutDetail({
        uuid,
        headers: {
          'X-PARTNER-ACCESS-KEY': partnerAccessKey,
        },
      });
    }
  }

  componentWillUnmount() {
    this.requestCheckoutDetail();
    this.checkoutDetailSuccess();
    this.checkoutDetailFailure();

    this.requestPaymentSubscription();
    this.paymentSubscriptionSuccess();
    this.paymentSubscriptionFailure();
  }

  onPaymentGenerated = () => {
    this.setState({ isLoading: false });
    this.props.history.push(`/transaction/sip${document.location.search}&?status=success`);
  };

  onCheckoutDetailFetched = (data) => {
    let sipDate = new Date().getDate();
    if (data?.oneClickCheckout?.startDate) {
      const date = data?.oneClickCheckout?.startDate.split('/');
      sipDate = date[0];
    }
    this.setState({
      isLoading: false,
      amount: data?.oneClickCheckout?.amount || '',
      sipDate: +sipDate,
      tempSipDate: +sipDate,
      minAmount: data?.oneClickCheckout?.minAmount || '',
    });
  };

  handleAmountChange = (event) => {
    this.setState({ amount: event.target.value });
  };

  handleInstallmentChange = (event) => {
    this.setState({ noOfInstallments: event.target.value });
  };

  openSipCalendar = () => {
    this.setState({ isSipCalendar: true });
  };

  closeSipCalendar = () => {
    this.setState({ isSipCalendar: false });
  };

  handleTempSipDateSelect = (date) => {
    this.setState({ tempSipDate: date });
  };

  updateSipDate = (date) => {
    this.setState({ sipDate: date }, this.closeSipCalendar);
  };

  handleOnSubmit = () => {
    this.setState({ isSubmit: true }, () => {
      const errors = this.handleValidations();
      if (errors?.isError) return;
      const { amount, sipDate, noOfInstallments } = this.state;
      const { href } = document.location;

      let { uuid, partnerAccessKey } = queryString.parse(this.props.location.search);
      this.props.requestGenerateCheckoutPaymentSip({
        body: {
          one_click_checkout: {
            amount: +amount,
            sip_day: +sipDate,
            number_of_installments: +noOfInstallments,
            mandate_redirect_url: `${href}&`,
          },
        },
        uuid,
        headers: {
          'X-PARTNER-ACCESS-KEY': partnerAccessKey,
        },
      });
    });
  };

  handleValidations = () => {
    const { isSubmit, amount, minAmount, noOfInstallments, minNoOfInstallments } = this.state;
    let errorStructure = {
      e_amount: '',
      e_noOfInstallments: '',
      isError: false,
    };
    if (!isSubmit) return errorStructure;
    if (!amount) {
      errorStructure = { ...errorStructure, e_amount: 'Please enter amount', isError: true };
    } else if (amount < minAmount) {
      errorStructure = {
        ...errorStructure,
        e_amount: `Amount must be greater than or equal to ${Convert.toCurrencyValue(minAmount)}`,
        isError: true,
      };
    }
    if (!noOfInstallments) {
      errorStructure = {
        ...errorStructure,
        e_noOfInstallments: 'Please enter no. of installments',
        isError: true,
      };
    } else if (noOfInstallments < minNoOfInstallments) {
      errorStructure = {
        ...errorStructure,
        e_noOfInstallments: `Min installment ${minNoOfInstallments}`,
        isError: true,
      };
    }
    return errorStructure;
  };

  render() {
    const errors = this.handleValidations();
    const { isLoading } = this.state;
    const { checkout } = this.props;
    const checkoutDetail = checkout?.checkoutDetail || {};
    let { reason, ...restParams } = queryString.parse(this.props.location.search);
    const status = restParams['?status'];

    return (
      <>
        {status ? (
          <SipTransactionsSuccess status={status} reason={reason} />
        ) : (
          <Screen>
            <div className={cx(styles['sip-transactions'])}>
              <div className={styles['mobile']}>
                <MobileSipTransactions
                  {...this.state}
                  errors={errors}
                  handleAmountChange={this.handleAmountChange}
                  handleInstallmentChange={this.handleInstallmentChange}
                  openSipCalendar={this.openSipCalendar}
                  closeSipCalendar={this.closeSipCalendar}
                  handleTempSipDateSelect={this.handleTempSipDateSelect}
                  updateSipDate={this.updateSipDate}
                  checkoutDetail={checkoutDetail}
                  handleOnSubmit={this.handleOnSubmit}
                />
              </div>
              <div className={styles['desktop']}>
                <DesktopSipTransactions
                  {...this.state}
                  errors={errors}
                  handleAmountChange={this.handleAmountChange}
                  handleInstallmentChange={this.handleInstallmentChange}
                  openSipCalendar={this.openSipCalendar}
                  closeSipCalendar={this.closeSipCalendar}
                  handleTempSipDateSelect={this.handleTempSipDateSelect}
                  updateSipDate={this.updateSipDate}
                  checkoutDetail={checkoutDetail}
                  handleOnSubmit={this.handleOnSubmit}
                />
              </div>
            </div>
          </Screen>
        )}
        <Loader loading={isLoading} />
      </>
    );
  }
}

export default withRouter(SipTransactions);
